import { useState } from "react";

import type { KeyValueStorage } from "../../pwa/installPromptState";
import { markPushPromptDismissed, shouldShowPushPrompt } from "../../pwa/pushOptIn";
import { usePushSubscription } from "../../pwa/usePushSubscription";

function safeLocalStorage(): KeyValueStorage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export default function EnablePushCard() {
  const { state, busy, error, enable } = usePushSubscription();
  const [storage] = useState<KeyValueStorage | null>(safeLocalStorage);
  const [visible, setVisible] = useState(() => {
    if (!storage) return false;
    try {
      return shouldShowPushPrompt(storage, Date.now());
    } catch {
      return false;
    }
  });

  if (!visible) return null;
  if (state !== "off" && state !== "ios-needs-install") return null;

  const dismiss = () => {
    if (storage) {
      try {
        markPushPromptDismissed(storage, Date.now());
      } catch {
        // storage lleno/bloqueado: solo ocultamos este montaje
      }
    }
    setVisible(false);
  };

  return (
    <div className="pwa-install-card" role="region" aria-label="Activar avisos">
      <span className="pwa-install-card__text">
        {state === "ios-needs-install"
          ? "Instala la app primero para recibir avisos de tus partidos en este iPhone."
          : "Recibe avisos de tus partidos y resultados en este dispositivo."}
      </span>
      {state === "off" ? (
        <button
          type="button"
          className="btn btn--primary"
          disabled={busy}
          onClick={() => void enable()}
        >
          Activar
        </button>
      ) : null}
      <button type="button" className="btn btn--secondary" onClick={dismiss}>
        Ahora no
      </button>
      {error ? <span className="pwa-install-card__steps">{error}</span> : null}
    </div>
  );
}
